module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"sendMessage":"Отправить сообщение","messageSent":"Сообщение отправлено","note":"Пометка с причиной отказа (для себя)","noteTip":"Кандидат не увидит эту пометку. Она нужна для того, чтобы в будущем было проще вспомнить, почему вы решили отказать.","send":"Отправить","cancel":"Очистить"}}')
  delete Component.options._Ctor
}
